const indexItems = [
  { letter: 'A', items: '暗黑破坏神 · 暗夜协奏曲 · 爱神巧克力' },
  { letter: 'B', items: '百炼成神 · 保护我方大大 · 霸道总裁爱上我' },
  { letter: 'C', items: '超神学院 · 穿越西元3000后 · 纯情丫头' },
  { letter: 'D', items: '斗破苍穹 · 斗罗大陆 · 大鱼海棠' },
  { letter: 'F', items: '凤囚凰 · 风云 · 封神纪' },
  { letter: 'H', items: '狐妖小红娘 · 火影忍者 · 海贼王' },
  { letter: 'Q', items: '全职高手 · 秦时明月 · 请吃红小豆吧' },
  { letter: 'W', items: '完美世界 · 武动乾坤 · 武庚纪' },
  { letter: 'Y', items: '一人之下 · 妖怪名单 · 英雄再临' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫画索引</h2>
          <p className="text-sm text-foreground-600">按拼音首字母快速查找51漫画在线全部作品</p>
        </div>

        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {indexItems.map((group, idx) => (
            <div
              key={idx}
              className={`flex items-stretch ${
                idx !== indexItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="w-14 flex items-center justify-center bg-primary-100/50 flex-shrink-0">
                <span className="text-heading text-xl text-primary-500 font-bold">{group.letter}</span>
              </div>
              <div className="flex-1 p-4 flex items-center">
                <p className="text-sm text-foreground-700 leading-relaxed">{group.items}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <p className="text-xs text-foreground-400">
            以上仅展示部分热门作品，51漫画在线收录超过十万部漫画，使用搜索功能发现更多精彩
          </p>
        </div>
      </div>
    </section>
  );
}